import React from 'react';
import { Users, Shield, AlertTriangle, Eye } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for VIP Profiles feature
 * Displays information about the VIP Profiles feature and its benefits
 */
export const VipProfilesFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="VIP Profiles"
      description="Monitor and protect high-value individuals in your organization with comprehensive digital risk monitoring and protection."
      icon={<Users className="h-8 w-8 text-blue-600" />}
      featureName="vip-profiles"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Users className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Executive Protection</h3>
          </div>
          <p className="text-gray-400">
            Monitor and protect your organization's executives and high-profile individuals from digital threats and exposures.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Eye className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Digital Footprint Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Track and monitor the digital footprint of VIPs, including social media presence, data exposures, and online mentions.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertTriangle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Threat Intelligence</h3>
          </div>
          <p className="text-gray-400">
            Receive targeted threat intelligence about potential risks to your VIPs, including impersonation attempts and targeted attacks.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Risk Assessment</h3>
          </div>
          <p className="text-gray-400">
            Evaluate and prioritize risks to VIPs with comprehensive risk scoring and actionable recommendations.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
